// frontend/src/utils/workExperienceUtils.js

export const WORK_EXP_INDUSTRY_OPTIONS = [
  { value: 'construction', label: 'Construction' },
  { value: 'building', label: 'Building & Architecture' },
  { value: 'engineering', label: 'Engineering' },
  { value: 'manufacturing', label: 'Manufacturing' },
  { value: 'process', label: 'Process (Petrochemical)' },
  { value: 'it_software', label: 'IT & Software' },
  { value: 'finance', label: 'Finance & Banking' },
  { value: 'healthcare', label: 'Healthcare' },
  { value: 'education', label: 'Education' },
  { value: 'retail', label: 'Retail & Consumer' },
  { value: 'logistics', label: 'Logistics & Transport' },
  { value: 'government', label: 'Government & Public Sector' },
  { value: 'consulting', label: 'Consulting' },
  { value: 'real_estate', label: 'Real Estate' },
  { value: 'hospitality', label: 'Hospitality & Tourism' },
  { value: 'other', label: 'Other' },
];

export const WORK_EXP_EMPLOYMENT_TYPE_OPTIONS = [
  { value: 'full_time', label: 'Full-time' },
  { value: 'part_time', label: 'Part-time' },
  { value: 'contract', label: 'Contract' },
  { value: 'freelance', label: 'Freelance' },
  { value: 'internship', label: 'Internship' },
  { value: 'volunteer', label: 'Volunteer' },
];

export const WORK_EXP_VERIFICATION_OPTIONS = [
  { value: 'pending', label: 'Pending Verification' },
  { value: 'verified', label: 'Verified' },
  { value: 'unverified', label: 'Not Verified' },
  { value: 'disputed', label: 'Disputed' },
];

const optionLabel = (options, value) => {
  if (!value) return '';
  return options.find((opt) => opt.value === value)?.label
    || value.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
};

export const getWorkExpIndustryLabel = (value) => optionLabel(WORK_EXP_INDUSTRY_OPTIONS, value);

export const getWorkExpEmploymentTypeLabel = (value) => (
  optionLabel(WORK_EXP_EMPLOYMENT_TYPE_OPTIONS, value)
);

export const getWorkExpVerificationLabel = (value) => (
  optionLabel(WORK_EXP_VERIFICATION_OPTIONS, value)
);

/**
 * Split a LinkedIn-style job description into clean bullet lines.
 */
export const splitWorkExperienceDescription = (text) => {
  if (!text || typeof text !== 'string') return [];
  return text
    .split(/\r?\n/)
    .map((line) => line.replace(/^[•\-\*]\s*/, '').trim())
    .filter(Boolean);
};
